import {
  toggleMenu, setLoading, setIsMobile,
} from './actions';

export default {
  toggleMenu,
  setLoading,
  setIsMobile,
};
